declare global {
    interface Window {
        env:any;
    }
}

const env = window.env;
export default env